import React, {Component} from 'react'

export default class NotFound extends Component {
  render () {
    return (
      <div className="pt-non-ideal-state" style={{paddingTop: '15%'}}>
        <div className="pt-non-ideal-state-visual pt-non-ideal-state-icon">
          <span className="pt-icon pt-icon-issue"></span>
        </div>
        <h4 className="pt-non-ideal-state-title">Página não encontrada.</h4>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/notFound/index.js